import React from 'react';
import { Switch } from 'react-router-dom';

import MyRoute from './myRoute';
import Login from '../pages/Login';
import Page404 from '../pages/Page404';
import Principal from '../pages/Principal';
import Disciplina from '../pages/Disciplina';
import Questoes from '../pages/Questoes';
import Prova from '../pages/Prova';
import Relatorios from '../pages/Relatorios';
import ProvasCompletas from '../pages/ProvasCompletas';

export default function Routes() {
  return (
    <Switch>
      <MyRoute exact path="/login" component={Login} isClosed={false} />
      <MyRoute exact path="/" component={Principal} isClosed />
      <MyRoute exact path="/disciplina/:id" component={Disciplina} isClosed />
      <MyRoute exact path="/questoes/:id/:questoes" component={Questoes} isClosed />
      <MyRoute exact path="/prova/:id" component={Prova} isClosed />
      <MyRoute exact path="/provascompletas/:id" component={ProvasCompletas} isClosed />
      <MyRoute exact path="/relatorios" component={Relatorios} isClosed />
      <MyRoute path="*" component={Page404} />
    </Switch>
  );
}
